import { PageType } from 'api/page-template/types';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useMeetingPagesRouteNavigations } from 'components/organisms/meeting-pages/route-navigations';
import { DocumentPage } from './document/page';

export type MeetingPagesPermissions = {
  canReadMeetingPages: boolean;
  canWriteMeetingPages?: boolean;
  canDeleteMeetingPages: boolean;
  canReadMeetingPageTemplates: boolean;
  canCreateMeetingPageTemplates: boolean;
  canWriteMeetingPageTemplates: boolean;
  canDeleteMeetingPageTemplates: boolean;
};

interface MeetingPageDocumentProps {
  projectId?: number;
  documentId?: number;
  accountId?: number;
  meetingPermissions?: MeetingPagesPermissions;
  isModuleFed?: boolean;
}

export const MeetingPageDocument = ({
  projectId,
  documentId: documentIdProp,
  accountId: accountIdProp,
  meetingPermissions,
  isModuleFed = true,
}: MeetingPageDocumentProps = {}) => {
  const params = useParams();
  const documentId = documentIdProp ?? Number(params.documentId);
  const accountId = accountIdProp ?? Number(params.accountId);
  const { navigateToMeeting, navigateToMeetingList } =
    useMeetingPagesRouteNavigations(projectId);

  // In module federation mode, use projectId as companyId for navigation
  // Otherwise, use accountId
  const companyIdForNavigation = projectId ?? accountId;

  const shouldBlock =
    isModuleFed &&
    meetingPermissions != null &&
    !meetingPermissions.canReadMeetingPages;

  useEffect(() => {
    if (shouldBlock) {
      navigateToMeetingList(companyIdForNavigation);
    }
  }, [shouldBlock, companyIdForNavigation, navigateToMeetingList]);

  if (shouldBlock) {
    return null;
  }

  return (
    <DocumentPage
      documentId={documentId}
      onBack={() => navigateToMeeting(companyIdForNavigation, documentId)}
      pageType={PageType.Meeting}
    />
  );
};
